// extracted by mini-css-extract-plugin
module.exports = {"tableContent":"TableContent_tableContent__1dQ96","virtuoso":"TableContent_virtuoso__1fbtV"};